import { Directive, inject, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[appRadioButtonLayoutOptionValue]',
  standalone: true,
})
export class RadioButtonLayoutOptionDirective {
  readonly templateRef = inject(TemplateRef<any>);
  private _value: any;
  @Input()
  set appRadioButtonLayoutOptionValue(value: any) {
    this._value = value;
  }
  get value(): any {
    return this._value;
  }
}
